var map = {
	"./de/returnBtn.png": "1XTj",
	"./en/returnBtn.png": "xfB0",
	"./es/returnBtn.png": "v4OP",
	"./fr/returnBtn.png": "uUN6",
	"./ja/returnBtn.png": "Yinr",
	"./ko/returnBtn.png": "C2DZ",
	"./pt/returnBtn.png": "rKsg",
	"./ru/returnBtn.png": "m3PM",
	"./tc/returnBtn.png": "Im5Y",
	"./th/returnBtn.png": "LpSe"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "oR1N";